import { Component, Input, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { FormGroup, AbstractControl, ReactiveFormsModule } from '@angular/forms';

import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-notification';
import { PartsManagementService } from '../../../services/parts-management.service';
import { CodeDescription } from '../../../models/code-description.model';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-create-part-details',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './create-part-details.component.html',
  styleUrls: ['./create-part-details.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CreatePartDetailsComponent implements OnInit {
  @Input() formGroup!: FormGroup;

  partGroups: CodeDescription[] = [];
  manufacturerCodes: CodeDescription[] = [];

  isLoadingPartGroups = false;
  isLoadingManufacturers = false;

  constructor(private readonly partsService: PartsManagementService) {}

  ngOnInit(): void {
    this.loadPartGroups();
    this.loadManufacturers();
  }

  async loadPartGroups(): Promise<void> {
    this.isLoadingPartGroups = true;
    try {
      const response = await firstValueFrom(this.partsService.getUniquePartGroupCodes());
      this.partGroups = response ?? [];
    } catch (error) {
      console.error('Error loading part groups', error);
      this.partGroups = [];
    } finally {
      this.isLoadingPartGroups = false;
    }
  }

  async loadManufacturers(): Promise<void> {
    this.isLoadingManufacturers = true;
    try {
      const response = await firstValueFrom(this.partsService.getUniquePartManufacturerCodes());
      this.manufacturerCodes = response ?? [];
    } catch (error) {
      console.error('Error loading manufacturers', error);
      this.manufacturerCodes = [];
    } finally {
      this.isLoadingManufacturers = false;
    }
  }

  isControlInErrorState(control: AbstractControl | null | undefined): boolean | null {
    return control?.invalid && control?.touched ? true : null;
  }
}
